import { useMediaQuery } from 'react-responsive';

export const use2Xl = () =>
  useMediaQuery({
    minWidth: 1520,
  });
